const apiKey = process.env.LAMBDA_RECOMMENDATION_API_KEY;
const lambdaRecommendationUrls = JSON.parse(
  process.env.LAMBDA_RECOMMENDATION_ENDPOINTS ?? "{}"
);
const newsRecommendationEndpoint = lambdaRecommendationUrls.news;
const productRecommendationEndpoint = lambdaRecommendationUrls.products;
const eventRecommendationEndpoint = lambdaRecommendationUrls.events;

export {
  newsRecommendationEndpoint,
  productRecommendationEndpoint,
  eventRecommendationEndpoint,
  apiKey
};
